import React from "react";
import PropTypes from "prop-types";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
const useStyles = makeStyles(() => ({
  icon: {
    marginLeft: 12,
    fontSize: "1.5rem",
    color: "rgba(0, 0, 0, 0.54)",
    "&:hover": {
      cursor: "default"
    }
  },
  tooltip: {
    color: "#fff",
    fontSize: "0.75rem",
    fontWeight: 700,
    maxWidth: 300,
    wordWrap: "break-word",
    "& a": {
      color: "#fff"
    }
  }
}));
const RadioSelection = ({
  tooltip
}) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const [isMobile, setIsMobile] = React.useState(false);
  React.useEffect(() => {
    const mq = matchMedia("(max-width: 450px)", onDeviceWidthChange);
    setIsMobile(mq.matches);
  }, []);
  const onDeviceWidthChange = mediaQuery => {
    setIsMobile(mediaQuery.matches);
  };
  const handleTooltipClose = () => {
    setOpen(false);
  };
  const handleTooltipOpen = () => {
    setOpen(!open);
  };
  const tooltipComponent = /*#__PURE__*/React.createElement("div", {
    className: classes.tooltip,
    dangerouslySetInnerHTML: {
      __html: tooltip
    }
  });
  const getMobileToolTip = () => {
    return /*#__PURE__*/React.createElement(ClickAwayListener, {
      onClickAway: handleTooltipClose
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tooltip, {
      PopperProps: {
        disablePortal: true
      },
      onClose: handleTooltipClose,
      open: open,
      disableFocusListener: true,
      disableHoverListener: true,
      disableTouchListener: true,
      title: tooltipComponent,
      arrow: true
    }, /*#__PURE__*/React.createElement(InfoIcon, {
      fontSize: "inherit",
      className: classes.icon,
      onClick: handleTooltipOpen
    }))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isMobile ? getMobileToolTip() : /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipComponent,
    arrow: true,
    placement: "right"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    fontSize: "inherit",
    className: classes.icon
  })));
};
export default RadioSelection;
RadioSelection.propTypes = {
  tooltip: PropTypes.string.isRequired
};